import React, { useState, useEffect } from "react";
import { getRegions } from "redux/actions/regionActions";
import { Typography, NotificationModal } from "components";
import GuarantorDetails from "./GuarantorDetails";
import kycSuccess from "assets/images/kyc-success.png";

import { useNavigate } from "react-router-dom";

const GuarantorForm = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleNext = () => {
    setShowModal(true);
  };

  useEffect(() => {
    getRegions();
  }, []);

  return (
    <div className="onboarding-container">
      <div>
        <Typography
          variant="heading3"
          className={"text-center mb-2"}
          state="primary"
        >
          Guarantor Information
        </Typography>
        <GuarantorDetails previouslySkipped={true} handleNext={handleNext} />
      </div>
      <NotificationModal
        showModal={showModal}
        image={<img src={kycSuccess} alt="" width="120" />}
        onClose={() => {
          navigate(-1);
          setShowModal(false);
        }}
        headerText="Guarantor Information Successfully submitted"
      />
    </div>
  );
};

export default GuarantorForm;
